import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicNavbar from "@/components/PublicNavbar";
import PublicFooter from "@/components/PublicFooter";
import WhatsAppButton from "@/components/WhatsAppButton";
import { api } from "@/lib/api";
import { BookOpen, ArrowRight, Clock } from "lucide-react";

export default function TestSeriesPublic() {
  const [items, setItems] = useState([]);
  const [hp, setHp] = useState(null);
  useEffect(() => {
    api.get("/public/test-series").then((r) => setItems(r.data || [])).catch(() => {});
    api.get("/public/homepage").then((r) => setHp(r.data)).catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-white">
      <PublicNavbar />
      <section className="bg-slate-50 border-b border-slate-200 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#F59E0B]">Test Series</div>
          <h1 className="heading mt-3 text-4xl sm:text-5xl font-bold">Secure, proctored online exams.</h1>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {items.length === 0 ? (
          <div className="p-14 rounded-2xl border border-dashed border-slate-300 text-center">
            <BookOpen size={40} className="mx-auto text-slate-300" />
            <div className="mt-4 text-slate-500">Tests launching soon.</div>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((t) => (
              <div key={t.id} className="p-6 rounded-2xl border border-slate-200 bg-white hover:shadow-lg transition">
                <div className="flex items-center gap-2">
                  <span className={`text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-0.5 rounded ${t.is_free ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`}>
                    {t.is_free ? "Free" : `₹${t.price}`}
                  </span>
                  <span className="text-xs text-slate-500 flex items-center gap-1"><Clock size={12} /> {t.duration_minutes} min</span>
                </div>
                <h3 className="heading text-lg font-bold mt-3">{t.title}</h3>
                <p className="mt-2 text-sm text-slate-600 line-clamp-3">{t.description}</p>
                <Link to="/login" className="mt-4 inline-flex items-center gap-1 text-brand font-semibold text-sm">
                  Login to enroll <ArrowRight size={14} />
                </Link>
              </div>
            ))}
          </div>
        )}
      </section>
      <PublicFooter contact={hp} />
      <WhatsAppButton number={hp?.whatsapp_number} />
    </div>
  );
}
